import { UseCase } from '@barkibu/noma-commons';
import { Adjustment } from '../../domain/adjustment/Adjustment';
import { AdjustmentRepository } from '../../domain/adjustment/AdjustmentRepository';

export const FindAdjustments = (repository: AdjustmentRepository): UseCase<Adjustment[]> => ({
    execute: async (claimRequestKey: string): Promise<Adjustment[]> => {
        return repository.findAllByClaimRequestKey(claimRequestKey);
    },
});
